import { render } from "./PageIndexEight.vue?vue&type=template&id=25cdbb60"
import script from "./PageIndexEight.vue?vue&type=script&lang=js"
export * from "./PageIndexEight.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__